import React from "react";
import { useDrag } from "react-dnd";

import { withStyles } from '@mui/styles';
import UiPidsConstructorStyles from "../UiPidsConstructorStyles";
import CommonStyles from "../../../../common/CommonStyles";
import PredicateChain from "../../../../common/PredicateChain";

const styles = {
  ...CommonStyles,
  ...UiPidsConstructorStyles,
};

const SideBarItem = ({ ancestor, data, classes, pids }) => {
  const item = { ...data };
  if (pids) item.component.pids = pids;
  const [{ opacity }, drag] = useDrag({
    type: "sidebarItem",
    item,
    collect: monitor => ({
      opacity: monitor.isDragging() ? 0.4 : 1
    })
  });
  
  return (
    <div ref={drag} style={{ opacity }}>
      {pids && ancestor ? 
        <div className={`${classes.sideBarItem} ${classes.alignCenter}`}>
        <span className={`${classes.mr5}`}>{`${data.component.type}`}</span>
        <div style={{ width: '100%' }}>
          <PredicateChain
            mode="view"
            rst={pids}
            showType={true}
            ancestor={ancestor}
          />
        </div>
      </div>
       : <div className={classes.sideBarItem}>{`${data.component.type}`}</div>
      }
    </div>
  );
};

export default withStyles(styles)(SideBarItem);
